"use client";
import { Button, Input, InputProps } from "antd";
import React from "react";
import style from "../style.module.scss";
import classNames from "classnames";
import { useRetrieveTitle } from "@/Utils/helpers";

interface FormInputProps extends InputProps {
  title?: string;
  langBtn?: boolean;
  setSelectedLang?: (e: any) => void;
  selectedLang?: string;
}

const FormInput: React.FC<FormInputProps> = ({
  title,
  langBtn = false,
  setSelectedLang,
  selectedLang,
  ...props
}) => {
  const { direction } = useRetrieveTitle();
  const lang = ["en-us", "ar-sa"];
  return (
    <>
      <div className={style.formInputWrapper}>
        {
          title && (
            <div className={style.text_wrapper}>
              <p className={style.text}>{title}</p>
            </div>
          )
        }
        <div className={style.langConatiner}>
          {langBtn && (
            <>

              {lang.map((langItem) => (
                <Button
                  key={langItem} // ✅ use stable key
                  size="small"
                  className={classNames({
                    [style.btn]: true,
                    [style.activeClass]: selectedLang === langItem,
                  })}
                  onClick={() => setSelectedLang && setSelectedLang(langItem)}
                >
                  {langItem}
                </Button>
              ))}
            </>
          )}
        </div>
        <Input dir={direction} className={style.input_field} {...props} />
      </div>
    </>
  );
};

export default FormInput;
